// convertToAPIErrors.ts
import isArray from "lodash-es/isArray";
import isEmpty from "lodash-es/isEmpty";
import { APIError } from "./useErrorMessageMapping";

// Fake type guard for Response
export const isAPIResponse = (obj: any): obj is Response => {
  return obj && typeof obj.json === "function";
};

export const convertToAPIErrors = async (
  error: APIError[] | Response | Error,
  t: (key: string) => string
): Promise<APIError[]> => {
  if (isArray(error)) return error;

  if (isAPIResponse(error)) {
    try {
      const body = await error.clone().json();
      if (isArray(body) && body.length > 0) return body as APIError[];
      throw new Error("API returned invalid error list");
    } catch (_e) {
      // fallback below
    }
  }

  const message =
    error instanceof Error && !isEmpty(error.message)
      ? error.message
      : t("error.message"); //  Use translated key

  return [{ key: "generic", source: "generic", message }];
};